import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "iran_dash_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  localStorage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export async function login(password) {
  const { data } = await axios.post(`${API}/auth/login`, { password });
  setToken(data.token);
  return data;
}
export async function verifyToken() {
  if (!getToken()) return false;
  try {
    await client.get("/auth/verify");
    return true;
  } catch {
    clearToken();
    return false;
  }
}
export async function fetchMeta() {
  const { data } = await client.get("/meta");
  return data;
}
export async function fetchSummary() {
  const { data } = await client.get("/summary");
  return data;
}
export async function fetchStatements(country, dateFrom, dateTo) {
  const params = {};
  if (country) params.country = country;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  const { data } = await client.get("/statements", { params });
  return data;
}
export async function fetchComparison() {
  const { data } = await client.get("/comparison");
  return data;
}
export async function fetchTimeline(emotion) {
  const { data } = await client.get("/timeline", { params: emotion ? { emotion } : {} });
  return data;
}
export async function triggerCollect() {
  const { data } = await client.post("/collect");
  return data;
}
export async function collectOneCountry(code) {
  const { data } = await client.get(`/collect/country/${code}`);
  return data;
}
export async function downloadWeeklyReport() {
  const response = await client.get("/report/weekly.pdf", { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  const now = new Date();
  const stamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}`;
  a.download = `iran-savasi-donem-raporu-${stamp}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
